import { keys } from './keys';

export const es = {
  [keys.productList.product.title]: 'Productos',
  [keys.productList.service.title]: 'Servicios',
  [keys.productList.operations.title]: 'Operaciones',
};
